import { ProfileBuilder } from './../builders/profile-builder';
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AdminProfileBuilder } from '../builders/admin-profile-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class ProfilesApiService {
    constructor(api) {
        this.api = api;
    }
    listProfiles() {
        return this.api.get('/user/profiles').toPromise().then(response => {
            return response.profiles.map(data => ProfileBuilder.buildProfile(data));
        });
    }
    getAdminProfile(id) {
        return this.api.get(`/user/profile/${id}`).toPromise().then(response => {
            return AdminProfileBuilder.buildAdminProfile(response.profile);
        });
    }
    getProfile(id) {
        return this.api.get(`/user/profile/${id}`).toPromise().then(response => {
            return ProfileBuilder.buildProfile(response.profile);
        });
    }
    createProfessionalProfile(profile) {
        let payload = ProfileBuilder.buildProfessionalProfilePayload(profile);
        return this.api.post('/user/profile', JSON.stringify(payload))
            .toPromise().then(response => ProfileBuilder.buildProfile(response.profile));
    }
    createAdminProfessionalProfile(profile) {
        let payload = ProfileBuilder.buildProfessionalProfilePayload(profile);
        return this.api.post('/user/profile', JSON.stringify(payload))
            .toPromise().then(response => AdminProfileBuilder.buildAdminProfile(response.profile));
    }
    updateProfessionalProfile(profile) {
        let payload = ProfileBuilder.buildProfessionalProfilePayload(profile);
        return this.api.put(`/user/profile/${profile.id}`, JSON.stringify(payload))
            .toPromise().then(response => ProfileBuilder.buildProfile(response.profile));
    }
    updateAdminProfessionalProfile(profile) {
        let payload = AdminProfileBuilder.buildAdminProfessionalProfilePayload(profile);
        return this.api.put(`/user/profile/${profile.id}`, JSON.stringify(payload))
            .toPromise().then(response => AdminProfileBuilder.buildAdminProfile(response.profile));
    }
    updateUserCompanyCostCenter(profile) {
        let payload = { id_costcenter: parseInt(profile.costCenterId) };
        return this.api.put(`/user/profile/${profile.id}`, JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    updateCorporateProfile(profile) {
        let payload = ProfileBuilder.buildCorporateProfilePayload(profile);
        return this.api.put(`/user/profile/${profile.id}`, JSON.stringify(payload))
            .toPromise().then(response => ProfileBuilder.buildCorporateProfile(response.profile));
    }
    updateAdminCorporateProfile(profile) {
        let payload = AdminProfileBuilder.buildAdminCorporateProfilePayload(profile);
        return this.api.put(`/user/profile/${profile.id}`, JSON.stringify(payload))
            .toPromise().then(response => AdminProfileBuilder.buildAdminCorporateProfile(response.profile));
    }
    updateCorporateProfileBlockPremium(idCompany, companyUser) {
        let payload = {
            block_premium_for_this_profile: companyUser.block_premium_for_this_profile,
            profile_id: companyUser.profileId
        };
        return this.api.put(`/business/users/${idCompany}`, JSON.stringify(payload))
            .toPromise().then(response => ProfileBuilder.buildCorporateProfile(response.profile));
    }
    deleteProfile(id) {
        return this.api.delete(`/user/profile/${id}`).toPromise().then(response => response);
    }
}
ProfilesApiService.ɵfac = function ProfilesApiService_Factory(t) { return new (t || ProfilesApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
ProfilesApiService.ɵprov = i0.ɵɵdefineInjectable({ token: ProfilesApiService, factory: ProfilesApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(ProfilesApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=profiles-api.service.js.map